import React, { Component, Fragment } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Card, message } from 'antd'
import GovernmentsApi from '../../../api/Governments'
import { withRouter } from 'react-router-dom'

class Contracts extends Component {
  api = new GovernmentsApi()

  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.state = {
      list: [],
      data: [],
      fetching: false,
      visible: false,
      type: 'new',
    }
  }

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      let list = await this.api.contracts.list(this.key)
      this.setState({ data: list, list, fetching: false })
    } catch (err) {
      message.error(err.errorMessage)
      this.setState({ fetching: false })
    }
  }

  columns = [
    {
      Header: 'ID',
      accessor: 'code',
    },
    {
      Header: 'Title',
      accessor: 'title',
    },
    {
      Header: 'Contracting Company',
      accessor: 'companyno',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },

    {
      Header: 'Country',
      accessor: 'country',
    },
    {
      Header: 'Action',
    },
  ]

  render() {
    return (
      <Fragment>
        <CustomTable
          isFilterable={true}
          fetch={fetch}
          loading={this.state.fetching}
          columns={this.columns}
          data={this.state.list}
        />
      </Fragment>
    )
  }
}

export default withRouter(Contracts)
